import React from "react";
import { BsEmojiDizzy } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ProjectsEndpoints } from "../../../Routes/api/Endpoints";
import { selectData } from "../../../redux/features/userSliceWithTokenValidation";
// import { useFetchProjectsQuery } from "../../../services/auth-services/AuthService";
import SkeletonLoader from "../../Utils/Skeleton";
import CardprojectComponent from "./CardprojectComponent";
import { useFetchProjectsQuery } from "../../../services/auth-services/TacheService";


function CardProject() {
  const {
    data: projets,
    error,
    isLoading,
    refetch,
  } = useFetchProjectsQuery(ProjectsEndpoints.getProjects, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skip: false,
  });
  const projetUser = useSelector(selectData);
  const location = useLocation();
  const userProjects = projets?.filter(
    (proj) => proj.user_id == projetUser?.porteur_projet?.id
  );

  const skeletonTab = Array.from({ length: 4 }, (_, i) => ({ id: `skeleton${i + 1}` }));

  return (
    <>
      {isLoading ? (
        <div className={`flex max-md:gap-5 gap-7 w-[100%] flex-wrap pb-1`}>
          {skeletonTab.map((elem, i) => (
            <SkeletonLoader cardProject={true} />
          ))}{" "}
        </div>
      ) : userProjects && userProjects.length > 0 ? (
        <div className="grid grid-cols-3 gap-4 pt-7 text-black xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {userProjects.map((elem, index) => (
            <CardprojectComponent
              key={index}
              image={elem?.image}
              budget={elem?.budget}
              titre={elem?.titre}
              etat={elem?.etat}
              objectif={elem?.objectif}
              path={`${location.pathname}/${elem?.slug}`}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center space-y-6 border py-24 mt-10 rounded-3xl w-full">

          <BsEmojiDizzy className="text-[10rem]" />
          <h1 className="text-xl font-semibold ">
            Aucun projet à affichier pour le moment
          </h1>

        </div>
      )}
    </>
  );
}

export default CardProject;
